<template>
  <TopImgBanner />
  <div
    id="gnb"
    ref="gnbRef"
    class="nav-background"
    role="banner"
  >
    <div class="gradient">
      <DesktopMenu
        class="mobile:hidden"
        :menu="getMenu"
        :mypage="getMypage"
        :sign-out="onSignOut"
        :is-authenticated="isAuthenticated"
      />
      <MobileMenu
        class="desktop:hidden"
        :menu="getMenu"
        :mypage="getMypage"
        :sign-out="onSignOut"
        :is-authenticated="isAuthenticated"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { Gnb } from '@/composables/useGnb';
import { useGnbMenu } from '@/composables/useGnbMenu';
import TopImgBanner from '@/components/layout/TopImgBanner.vue';
import DesktopMenu from './Desktop.vue';
import MobileMenu from './Mobile.vue';
import { resetUser } from '@/utils/mixpanel';
import { datadogRum } from '@datadog/browser-rum';

const router = useRouter();
const route = useRoute();
const store = useStore();
const gnbRef = ref<HTMLElement>();
const { getMenu, getMypage } = useGnbMenu();
const useGnb = new Gnb({
  classBackground: 'nav-background-white',
  classBackgroundOpacity: 'nav-background-transparent',
  applyRouter: ['/', '/service'],
});

const isAuthenticated = computed(() => !!store.getters['auth/getSessionToken']());

const onSignOut = () => {
  store.dispatch('auth/updateSessionToken', '');
  store.dispatch('auth/updateClientInfo', {
    name: '',
  });
  store.dispatch('auth/updateCenterInfo', {
    name: '',
  });
  store.dispatch('localStorage/saveToLocalStorage');
  resetUser();
  router.push('/');

  datadogRum.clearUser();
};

onMounted(() => {
  useGnb.init(gnbRef.value!);
  useGnb.applyByPath(route.path);

  router.beforeEach(async (to, from) => {
    useGnb.applyByPath(to.path);
  });
});
</script>
<style lang="scss" scoped>
.nav-background {
  @apply border-b z-[101] w-full sticky left-0 right-0 bg-transparent desktop:top-0 mobile:top-0;
  &-transparent {
    @apply bg-transparent border-b-transparent;
    color: rgba(255, 255, 255, 0.7);

    background-position: top top;

    :deep(img) {
      filter: brightness(0) invert(1);
    }
    :deep(.router-link-active) {
      @apply text-white border-white;
    }

    .gradient {
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(238, 238, 238, 0));
    }
  }
  &-white {
    @apply bg-white border-black2 text-black9;

    :deep(.divide) {
      @apply text-black7;
    }

    :deep(.router-link-active) {
      @apply text-primary border-primary font-bold;
    }
    :deep(.router-link-exact-active) {
      @apply text-primary;
    }
  }
}
</style>
